import Vue from 'vue';

Vue.mixin({
  methods: {
    baseUrl(file) {
      return `${process.env.BASE_URL}${file}`;
    },
  },
});
